import state from './moduleStoreAlertNotificationState.js';
import mutations from './moduleStoreAlertNotificationMutations.js';
import actions from './moduleStoreAlertNotificationActions.js';
import getters from './moduleStoreAlertNotificationGetters.js';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
